import { createStore, applyMiddleware, compose } from 'redux';
import penderMiddleware from 'redux-pender';

import reducers from 'modules';

const composed = process.env.NODE_ENV === 'production' ? compose : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const composeEnhancers = composed;

const store = createStore(
    reducers,
    composeEnhancers(
        applyMiddleware(penderMiddleware()
    )
));

export default store;



// WEBPACK FOOTER //
// ./src/store.js